import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { compileDocumentToHtml } from "../services/htmlCompiler";

const PreviewCanvas = ({ document, onCompile, fillHeight = false }) => {
  const { html, errors } = useMemo(
    () => compileDocumentToHtml(document, { preview: fillHeight }),
    [document, fillHeight]
  );
  const [iframeHeight, setIframeHeight] = useState(480);

  useEffect(() => {
    onCompile(errors || []);
  }, [document, errors, onCompile]);

  useEffect(() => {
    setIframeHeight(480);
  }, [html]);

  const handleLoad = (event) => {
    try {
      const doc = event.target.contentDocument;
      const height = doc?.documentElement?.scrollHeight || doc?.body?.scrollHeight || 480;
      const nextHeight = fillHeight
        ? Math.max(height, 320)
        : Math.min(Math.max(height + 16, 320), 1400);
      setIframeHeight(nextHeight);
    } catch {
      setIframeHeight(480);
    }
  };

  if (!html) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ p: 2, textAlign: "center" }}>
        Nessun contenuto da visualizzare. Aggiungi un layout e dei componenti.
      </Typography>
    );
  }

  if (fillHeight) {
    return (
      <Box
        component="iframe"
        title="Anteprima newsletter"
        srcDoc={html}
        scrolling="no"
        onLoad={handleLoad}
        sx={{
          width: "100%",
          height: iframeHeight,
          minHeight: 320,
          border: 0,
          display: "block",
          backgroundColor: "#fff",
        }}
      />
    );
  }

  return (
    <Box sx={{ minHeight: 320 }}>
      <Box
        sx={{
          maxWidth: 640,
          mx: "auto",
          backgroundColor: "#fff",
        }}
      >
        <Box
          component="iframe"
          title="Anteprima newsletter"
          srcDoc={html}
          onLoad={handleLoad}
          sx={{
            width: "100%",
            height: iframeHeight,
            border: 0,
            display: "block",
          }}
        />
      </Box>
    </Box>
  );
};

PreviewCanvas.propTypes = {
  document: PropTypes.object.isRequired,
  onCompile: PropTypes.func.isRequired,
  fillHeight: PropTypes.bool,
};

export default PreviewCanvas;
